module.exports = __webpack_public_path__ + "assets/db01b2dfff1e90adb4bdfd7f41487cb0.png";